import { render, staticRenderFns } from "./drawer_form.vue?vue&type=template&id=1402581c&scoped=true&"
import script from "./drawer_form.vue?vue&type=script&lang=ts&"
export * from "./drawer_form.vue?vue&type=script&lang=ts&"
import style0 from "./drawer_form.vue?vue&type=style&index=0&id=1402581c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1402581c",
  null
  
)

export default component.exports